export default class Sprite extends PIXI.Sprite{
  constructor(data) {
    super(data.texture)
    this._data = data

  }

  get data(){
    return this._data
  }
}
